// extracted by mini-css-extract-plugin
export var completionBody = "_kx-2";
export var completionCard = "_kx-0";
export var completionFooter = "_kx-3";
export var completionTitle = "_kx-1";